import Field from './Field';

export default class FullNameField extends Field {
  constructor(keyFirstName, keyLastName, label = '', options = {}) {
    super('fullName', label, options);
    this.keyFirstName = keyFirstName;
    this.keyLastName = keyLastName;
  }

  hasValue(data) {
    return data && (!!data[this.keyFirstName] || !!data[this.keyLastName]);
  }

  getValue(data) {
    return this.hasValue(data)
      ? [
          ...(data[this.keyFirstName] ? [data[this.keyFirstName]] : []),
          ...(data[this.keyLastName] ? [data[this.keyLastName]] : [])
        ].join(' ')
      : '';
  }
}
